// Polyfill Object.hasOwn for older JavaScript runtimes (e.g. Chrome Mobile <93)
if (typeof Object.hasOwn !== 'function') {
  Object.hasOwn = (object: object, property: PropertyKey): boolean => {
    if (object === null || object === undefined) {
      throw new TypeError('Cannot convert undefined or null to object')
    }
    return Object.prototype.hasOwnProperty.call(object, property)
  }
}

// HTTP requests (stores, passkeys, uploads) use the native fetch/XHR client in
// ./lib/http.

// Monkey patch URL constructor to handle about:srcdoc in iframe context
if (typeof window !== 'undefined') {
  const OriginalURL = window.URL
  class SafeURL extends OriginalURL {
    constructor(url: string | URL, base?: string | URL) {
      let safeBase = base
      if (base) {
        const baseStr = base.toString()
        if (baseStr.startsWith('about:')) {
          let originFallback = 'http://localhost'
          try {
            if (
              window.location &&
              window.location.origin &&
              window.location.origin !== 'null' &&
              !window.location.origin.startsWith('about:')
            ) {
              originFallback = window.location.origin
            } else if (
              window.parent &&
              window.parent.location &&
              window.parent.location.origin &&
              window.parent.location.origin !== 'null' &&
              !window.parent.location.origin.startsWith('about:')
            ) {
              originFallback = window.parent.location.origin
            }
          } catch {
            // Cross-origin parent access throws; keep the localhost fallback.
          }
          safeBase = originFallback
        }
      }
      super(url, safeBase)
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.URL = SafeURL as any
}
